import axios from "axios";
import type { AxiosResponse } from "axios";

export interface CreateCustomerResponse {
  customerId: string;
}

export function createCustomer(
  email: string
): Promise<AxiosResponse<CreateCustomerResponse>> {
  return axios.post("/.netlify/functions/create-customer", { email });
}
